exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sidebar[data-v-ab16be24]{.nav[data-v-ab16be24]{.nav-item[data-v-ab16be24]{.nav-link[data-v-ab16be24]{.menu-title[data-v-ab16be24]{color:#fff}.icon-wrapper[data-v-ab16be24]{background-color:#91ade8;svg[data-v-ab16be24]{color:#fff}}}}.nav-item.active[data-v-ab16be24]{background-color:#f0fff0!important;.menu-title[data-v-ab16be24]{color:#000!important}.icon-wrapper[data-v-ab16be24]{background-color:#019aff!important;color:#fff}}}}", ""]);

// exports
